var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPaintBucket = function SvgIconPaintBucket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.535.793a1 1 0 0 0-1.414 0L6.539 4.375l-2.28-2.279A1 1 0 1 0 2.847 3.51l2.279 2.28-4.023 4.022-.005.005a2.51 2.51 0 0 0 0 3.522l.005.006 7.96 7.959.005.005a2.51 2.51 0 0 0 3.522 0l.005-.005 9.02-9.019a1 1 0 0 0 0-1.414zM6.54 7.203l-4.02 4.02a.51.51 0 0 0 0 .71l.003.003 7.948 7.949.002.001a.51.51 0 0 0 .712 0l.002-.001 8.306-8.307-8.664-8.664L7.953 5.79l2.192 2.192A3.25 3.25 0 1 1 8.73 9.395zm3.836 3.672a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.707 15.793 21 16.5l-.707-.707a1 1 0 0 1 1.414 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m21 16.5-.707-.707-.002.002-.002.002-.007.007-.022.022-.072.076q-.091.097-.24.27a10 10 0 0 0-.718.945c-.502.753-1.105 1.895-1.105 3.133a2.875 2.875 0 1 0 5.75 0c0-1.238-.604-2.38-1.105-3.133a10 10 0 0 0-1.03-1.29l-.022-.023-.007-.007-.002-.002-.001-.001zm0 1.573q-.053.074-.105.154c-.436.653-.77 1.386-.77 2.023a.875.875 0 1 0 1.75 0c0-.637-.334-1.37-.77-2.023z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconPaintBucket;